import { render } from "./FoerderorgAnsprechpartnerModalZuweisen.pug?vue&type=template&id=4a62b266&lang=pug"
import script from "./FoerderorgAnsprechpartnerModalZuweisen.js?vue&type=script&lang=js"
export * from "./FoerderorgAnsprechpartnerModalZuweisen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__